var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FB7B33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9138 8.91244C16.1416 8.68463 16.1416 8.31529 15.9138 8.08748C15.686 7.85967 15.3166 7.85967 15.0888 8.08748L12.0013 11.175L8.91378 8.08748C8.68598 7.85967 8.31663 7.85967 8.08882 8.08748C7.86102 8.31529 7.86102 8.68463 8.08882 8.91244L11.1763 12L8.08882 15.0875C7.86102 15.3153 7.86102 15.6846 8.08882 15.9124C8.31663 16.1402 8.68598 16.1402 8.91378 15.9124L12.0013 12.8249L15.0888 15.9124C15.3166 16.1402 15.686 16.1402 15.9138 15.9124C16.1416 15.6846 16.1416 15.3153 15.9138 15.0875L12.8263 12L15.9138 8.91244Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedIcon);
export default __webpack_public_path__ + "static/media/selected-icon.90c2debf24b1414a8ee4f0e1fa16a577.svg";
export { ForwardRef as ReactComponent };